import { Group, Menu, UnstyledButton, useMantineTheme } from '@mantine/core'
import { r } from 'config/routes'
import { CSSProperties, useMemo, useState } from 'react'
import { TbChevronDown } from 'react-icons/tb'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from 'store/authStore'
import { useCustomizerActions, useCustomizerStore } from 'store/customizerStore'
import classes from './PickerControl.module.css'

export type TWorkspaceType = 'lorawan' | 'snmp' | 'admin'
const workspaces = new Map<TWorkspaceType, { label: string }>()
workspaces.set('lorawan', { label: 'LoRaWAN' })
// workspaces.set('snmp', { label: 'SNMP' })
workspaces.set('admin', { label: 'Admin' })

export function WorkspacePicker() {
  const navigate = useNavigate()
  const [opened, setOpened] = useState(false)
  const theme = useMantineTheme()
  const selectedWorkspace = useCustomizerStore(state => state.selectedWorkspace)
  const { setWorkspace } = useCustomizerActions()
  const handleSelect = (id: TWorkspaceType) => () => {
    navigate(r['panel'])
    setWorkspace(id)
  }
  const userRoles = useAuthStore(state => state.user?.role)

  const admin = userRoles?.includes('Admin')
  const controlStyle = {
    '--picker-border-color': 'rgba(255, 255, 255, 0.14)',
    '--picker-border-radius': theme.radius.sm,
    '--picker-background-color': opened
      ? 'rgba(255, 255, 255, 0.12)'
      : 'rgba(255, 255, 255, 0.06)',
    '--picker-hover-background-color': 'rgba(255, 255, 255, 0.1)',
    '--picker-color': '#f3f5fa',
    '--picker-icon-rotation': opened ? '180deg' : '0deg',
  } as CSSProperties

  const items = useMemo(
    () =>
      Array.from(workspaces)
        .filter(workspace =>
          workspace[0] === 'admin'
            ? userRoles?.includes('Admin')
              ? true
              : false
            : true,
        )
        .map(([id, { label }]) => {
          return (
            <Menu.Item onClick={handleSelect(id)} key={id}>
              {label}
            </Menu.Item>
          )
        }),
    [userRoles],
  )

  return admin ? (
    <Menu
      onOpen={() => setOpened(true)}
      onClose={() => setOpened(false)}
      radius="sm"
      width={'target'}
      transitionProps={{
        transition: 'pop-top-left',
      }}
    >
      <Menu.Target>
        <UnstyledButton
          className={`${classes.control} ${classes.workspaceControl} workspace-picker`}
          style={controlStyle}
        >
          <Group gap="xs">
            <span className={classes.label}>
              {workspaces.get(selectedWorkspace)?.label}
            </span>
          </Group>
          <TbChevronDown size={16} className={classes.icon} />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>{items}</Menu.Dropdown>
    </Menu>
  ) : null
}
